import home from './src/home.vue'
import LampConcentratorView from './src/LampManager/LampConcentratorView.vue' //回路列表
import LampConcentratorInfo from './src/LampManager/LampConcentratorInfo.vue' //回路详情
import LampView from './src/LampManager/LampView.vue' //路灯列表
import LampInfo from './src/LampManager/LampInfo.vue' //路灯详情

let views = {
    home,
    LampConcentratorView,
    LampConcentratorInfo,
    LampView,
    LampInfo
};

export default views;